export const T = {
  en_GB: {
    cancel: "Cancel",
    add: "Add goal",
    save: "Save",
    addGoalTitle: "Add goal",
    addGoalDescription: "Enter the details of the new goal.",
    editGoalTitle: "Edit goal",
    editGoalDescription: "Update the goal details and save.",
    platformRequired: "Select a platform",
    failedToSetPlatform: "Failed to set platform",
    failedToUpdateGoal: "Failed to save goal",
    goalName: "Goal Name",
    goalNamePlaceholder: "e.g., Retirement Fund",
    nameRequired: "Goal name is required",
    typeRequired: "Select a goal type",
    failedToCreateGoal: "Failed to create goal",
  },
  nb_NO: {
    cancel: "Avbryt",
    add: "Legg til mål",
    save: "Lagre",
    addGoalTitle: "Legg til mål",
    addGoalDescription: "Fyll inn detaljene for det nye målet.",
    editGoalTitle: "Rediger mål",
    editGoalDescription: "Oppdater måldetaljene og lagre.",
    platformRequired: "Velg en plattform",
    failedToSetPlatform: "Kunne ikke velge plattform",
    failedToUpdateGoal: "Kunne ikke lagre mål",
    goalName: "Målnavn",
    goalNamePlaceholder: "f.eks., Pensjonsfond",
    nameRequired: "Målnavn er påkrevd",
    typeRequired: "Velg en måltype",
    failedToCreateGoal: "Kunne ikke opprette mål",
  },
} as const;
